import React, { Suspense } from "react";
import { MapPin, Plane, Star } from "lucide-react";
import { visit_places } from "../utils/Venue/Venue";
import { banner_style } from "../Styles/styles";
import VenueMap from "../components/ui/VenueMap";


const Venue = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center text-4xl font-bold">
      <div
        className={`${banner_style} venue-banner`}
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1606857521015-7f9fcf423740?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8b2ZmaWNlfGVufDB8fDB8fHww')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h2 className="text-slate-100 text-3xl sm:text-5xl md:text-6xl font-bold px-4">
          Our Venue
        </h2>
      </div>
      <div className="flex flex-col items-center text-center">
        <h2 className="text-base md:text-lg font-normal text-one mb-4">
          Proposed Conference Venue
        </h2>
        <h1 className="text-xl md:text-2xl gap-2 flex flex-row items-center justify-center">
          {/* <MapPin /> Coming Soon */}
        </h1>
        <p className="text-sm md:text-[15px] flex flex-row items-center font-normal justify-center">
          <Plane className="mr-1" />
          {/* Valencia International Airport (Manises), Valencia, Spain */} 
          {/* Coming soon */}
        </p>
        <h3 className="text-sm md:text-[18px] gap-2 font-normal flex flex-row items-center justify-center">
          <Star size={18} /> 4.5 rating
        </h3>
      </div>

      <div className="flex flex-col lg:flex-row items-center justify-center my-6 gap-6 w-full px-4">
        <div className="lg:w-[40vw] max-w-2xl">
          <img
            src="https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069&auto=format&fit=crop"
            alt="Venue"
            loading="lazy"
            className="w-full h-[30vh] md:h-[40vh] lg:h-[50vh] object-cover rounded-xl shadow-md"
          />
        </div>
        <div className="w-full lg:w-[40vw] max-w-2xl z-0">
          <Suspense fallback={<div className='w-full h-[50vh] flex items-center justify-center bg-gray-100 rounded-xl'>Loading map...</div>}>
            <VenueMap />
          </Suspense>
        </div>
      </div>

      {/* <h1 className="my-8 text-2xl md:text-3xl text-center">Places to visit near the Venue</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 justify-center gap-4 md:px-12 w-full md:mb-8 mb-2">
        {visit_places.map((item, index) => (
          <div key={index} className="flex gap-2 flex-col px-4 text-left items-start">
            <img
              src={item.image}
              alt={item.name}
              loading="lazy"
              className="h-28 w-full sm:w-44 object-cover rounded-xl"
            />
            <h1 className="text-sm md:text-[16px] font-normal leading-tight">
              {item.name}
            </h1>
            <p className="text-sm md:text-[16px] leading-tight flex flex-row font-normal items-center text-one">
              <MapPin size={16} className="mr-1" /> {item.km}km
            </p>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default Venue;